import { render } from "./InterfaceEmojiPicker.vue?vue&type=template&id=9c167864&scoped=true"
import script from "./InterfaceEmojiPicker.vue?vue&type=script&lang=js"
export * from "./InterfaceEmojiPicker.vue?vue&type=script&lang=js"

import "./InterfaceEmojiPicker.vue?vue&type=style&index=0&id=9c167864&scoped=true&lang=scss"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c167864"]])

export default __exports__